// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3rmJp","sendOtp":"AuthorizeToLogin_sendOtp__RPALu"};